import {
  AccountManagerColumn,
} from '../../../../sources/charting_library.min';
import {
  StandardFormatterName,
} from '../../../../sources/charting_library';
import { ITVFunds } from './types';

type TCustomizedAccountManagerColumn =
  AccountManagerColumn & { property: keyof ITVFunds }

export const fundsTableColumns: TCustomizedAccountManagerColumn[] = [
  {
    id: 'segment',
    label: 'Segment',
    notSortable: true,
    property: 'segment',
    formatter: StandardFormatterName.Symbol,
		dataFields: ['segment', 'segment'],
  },
  {
    id: 'availableBalance',
    label: 'Available Balance',
    notSortable: true,
    property: 'availableBalance',
    formatter: StandardFormatterName.Text,
    dataFields: ['availableBalance'],
  },
  {
    id: 'marginUtilized',
    label: 'Margin utilized',
    notSortable: true,
    property: 'marginUtilized',
    formatter: StandardFormatterName.Text,
    dataFields: ['marginUtilized'],
  },
  {
    id: 'Opening balance',
    label: 'Opening balance',
    property: 'openingBalance',
    notSortable: true,
    formatter: StandardFormatterName.Text,
    dataFields: ['openingBalance'],
  },
  {
    id: 'unsettledFunds',
    label: 'Unsettled funds',
    property: 'unsettledFunds',
    notSortable: true,
    formatter: StandardFormatterName.Text,
    dataFields: ['unsettledFunds'],
  },
  {
    id: 'withdrawableBalance',
    label: 'Withdrawable balance',
    property: 'withdrawableBalance',
    notSortable: true,
    formatter: StandardFormatterName.Text,
    dataFields: ['withdrawableBalance'],
  },
  {
    id: 'withdrawInProgress',
    label: 'Withdraw in progress',
    property: 'withdrawInProgress',
    notSortable: true,
    formatter: StandardFormatterName.Text,
    dataFields: ['withdrawInProgress'],
  },
  {
    id: 'collateralMargin',
    label: 'Collateral margin',
    property: 'collateralMargin',
    notSortable: true,
    formatter: StandardFormatterName.Text,
    dataFields: ['collateralMargin'],
  },
];
